var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderStatusBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_5655",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_5655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 29.3334C8.63535 29.3334 2.66602 23.364 2.66602 16C2.66602 8.63602 8.63535 2.66669 15.9993 2.66669C23.3633 2.66669 29.3327 8.63602 29.3327 16C29.3327 23.364 23.3633 29.3334 15.9993 29.3334ZM15.9993 26.6667C18.8283 26.6667 21.5414 25.5429 23.5418 23.5425C25.5422 21.5421 26.666 18.829 26.666 16C26.666 13.171 25.5422 10.4579 23.5418 8.45755C21.5414 6.45716 18.8283 5.33335 15.9993 5.33335C13.1704 5.33335 10.4573 6.45716 8.45688 8.45755C6.45649 10.4579 5.33268 13.171 5.33268 16C5.33268 18.829 6.45649 21.5421 8.45688 23.5425C10.4573 25.5429 13.1704 26.6667 15.9993 26.6667ZM15.9993 22.6667C14.2312 22.6667 12.5355 21.9643 11.2853 20.7141C10.0351 19.4638 9.33268 17.7681 9.33268 16C9.33268 14.2319 10.0351 12.5362 11.2853 11.286C12.5355 10.0357 14.2312 9.33335 15.9993 9.33335C17.7675 9.33335 19.4632 10.0357 20.7134 11.286C21.9636 12.5362 22.666 14.2319 22.666 16C22.666 17.7681 21.9636 19.4638 20.7134 20.7141C19.4632 21.9643 17.7675 22.6667 15.9993 22.6667Z",
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderStatusBlack);
export default __webpack_public_path__ + "static/media/order-status-black.83031ae3fc919fcf6875605268fecdb9.svg";
export { ForwardRef as ReactComponent };